var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.screen.width >= 990)?_c('container'):_vm._e(),(_vm.screen.width <= 989)?_c('containerMobile'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }